// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__Fh5dx","stylit":"Header_stylit__ZjjPU","hoverinbac":"Header_hoverinbac__s7Fjg"};